export const ErrorIcon = () => (
  <svg width="16" height="16" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>Error outline</title>
    <path
      d="M6.33331 9.00004H7.66665V10.3334H6.33331V9.00004ZM6.33331 3.66671H7.66665V7.66671H6.33331V3.66671ZM6.99331 0.333374C3.31331 0.333374 0.333313 3.32004 0.333313 7.00004C0.333313 10.68 3.31331 13.6667 6.99331 13.6667C10.68 13.6667 13.6666 10.68 13.6666 7.00004C13.6666 3.32004 10.68 0.333374 6.99331 0.333374ZM6.99998 12.3334C4.05331 12.3334 1.66665 9.94671 1.66665 7.00004C1.66665 4.05337 4.05331 1.66671 6.99998 1.66671C9.94665 1.66671 12.3333 4.05337 12.3333 7.00004C12.3333 9.94671 9.94665 12.3334 6.99998 12.3334Z"
      fill="#D85349"
    />
  </svg>
);
